import { useEffect, useState } from "react";
import { Crown, PartyPopper, Check } from "lucide-react";
import { toast } from "sonner";
import { api, formatErr } from "@/lib/api";
import { confetti } from "@/lib/celebrate";
import { UserAvatar, UserLink } from "@/components/UserBits";
import { timeAgo } from "@/lib/timeAgo";

export function DayHighlight() {
  const [h, setH] = useState(null);
  const load = () => api.get("/notifications/highlight").then(({ data }) => setH(data)).catch(() => {});
  useEffect(() => { load(); }, []);
  if (!h) return null;
  const cheer = async (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    try { await api.post("/notifications/highlight/congrats"); confetti({ x: r.left + r.width / 2, y: r.top, count: 50, colors: ["#FBBF24", "#FDE68A", "#F59E0B"] }); load(); }
    catch (err) { toast.error(formatErr(err)); }
  };
  return (
    <div className="relative overflow-hidden rounded-3xl p-4 bg-gradient-to-br from-[#fff3c9] via-[#f6e3a1] to-[#e6c56f] ring-1 ring-[#c99a3c] shadow-md shadow-amber-200/60 text-[#4a2a08]" data-testid="day-highlight">
      <div className="absolute inset-0 vault-sheen pointer-events-none" />
      <p className="relative text-[11px] font-extrabold uppercase tracking-[0.2em] flex items-center gap-1.5"><Crown className="w-4 h-4 fill-amber-500 text-amber-600" /> Größter Gewinn des Tages</p>
      <div className="relative mt-3 flex items-center gap-3">
        <div className="relative shrink-0 rounded-full ring-4 ring-amber-300/80">
          <UserAvatar userId={h.user.user_id} name={h.user.name} picture={h.user.picture} size="w-14 h-14" text="text-lg" />
        </div>
        <div className="min-w-0 flex-1">
          <UserLink id={h.user.user_id} className="font-extrabold truncate block">{h.user.name}</UserLink>
          <p className="text-xs opacity-80 break-words" data-testid="day-highlight-reason">{h.reason}</p>
          <p className="text-[11px] opacity-60">{timeAgo(h.created_at)}</p>
        </div>
        <p className="shrink-0 font-display text-3xl font-black text-amber-700 tabular-nums" data-testid="day-highlight-points">+{h.points.toLocaleString("de-DE")}</p>
      </div>
      <div className="relative mt-3 flex items-center justify-between gap-2">
        <span className="text-xs font-bold opacity-80" data-testid="day-highlight-count">{h.congrats ? `${h.congrats} ${h.congrats === 1 ? "Glückwunsch" : "Glückwünsche"}` : "Sei der Erste, der gratuliert!"}</span>
        {!h.is_me && (
          <button onClick={cheer} disabled={h.mine} data-testid="day-highlight-congrats" className="h-10 px-4 rounded-full bg-gradient-to-r from-[#7a1c3a] to-[#b3164f] text-white text-sm font-extrabold inline-flex items-center gap-1.5 disabled:opacity-60 active:scale-95 transition-transform">
            {h.mine ? <><Check className="w-4 h-4" /> Gratuliert</> : <><PartyPopper className="w-4 h-4" /> Glückwunsch</>}
          </button>
        )}
      </div>
    </div>
  );
}
